import Icon from './icon/icon.vue'

export default [
  Icon
]
